import script from "./ChineseFundedOverseas.vue?vue&type=script&setup=true&lang=js"
export * from "./ChineseFundedOverseas.vue?vue&type=script&setup=true&lang=js"

import "./ChineseFundedOverseas.vue?vue&type=style&index=0&id=c8e21636&lang=scss"

const __exports__ = script;

export default __exports__